import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'

import { useCallback, useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { AgGridReact } from 'ag-grid-react'
import { Button, Icon } from 'antd'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../components/CustomButtons/addNewButton'
import ExportButton from '../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../components/CustomGlobalSearchInput/globalSearchInput'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'

export default function ListTopConsultantsTypes() {
  const history = useHistory()
  const [globalSearch, setGlobalSearch] = useState()
  const [rowData, setRowData] = useState([])

  const gridApi = useRef(null)

  useEffect(() => {
    async function ListTopConsultantsTypes() {
      try {
        const data = await request(api.getTopConsultantsList())
        setRowData(data)
      } catch (error_) {
        console.tron.log(error_)
      }
    }

    ListTopConsultantsTypes()
  }, [])

  const columnDefs = [
    {
      headerName: 'Nome',
      field: 'name',
      width: 800,
      filter: 'agTextColumnFilter',
      cellStyle: ({ data }) => {
        if (data && !data.active) {
          return {
            color: '#999999'
          }
        }
      }
    },
    {
      headerName: 'Editar',
      field: 'id',
      sortable: false,
      resizable: false,
      cellRenderer: (params) => {
        return (
          <Link to={`/topConsultantsTypes/${params.value}`}>
            <Button
              type="ghost"
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'none' }}
            >
              <Icon type="edit" size="small" />
            </Button>
          </Link>
        )
      }
    }
  ]

  const defaultColDef = {
    sortable: true,
    resizable: true,
    minWidth: 100,
    width: 100,
    floatingFilter: true
  }

  const onGridReady = useCallback(async (params) => {
    gridApi.current = params.api
    params.api.sizeColumnsToFit()
  }, [])

  const sizeColumnsToFit = useCallback(
    (params) => {
      params.api.sizeColumnsToFit()
    },
    [rowData]
  )

  return (
    <>
      <Toolbar
        start={
          <h2>
            <b>Top Consultorias - Líderes da Soja</b>
          </h2>
        }
        end={
          <div className="container-header-lists">
            <GlobalSearchInput
              value={globalSearch}
              onChange={(e) => {
                setGlobalSearch(e.target.value)
                gridApi?.current.setGridOption('quickFilterText', e.target.value)
              }}
            />

            <div>
              <ExportButton
                iconType="csv"
                label={getMessage('label.exportCvs')}
                onClick={() => gridApi?.current.exportDataAsCsv()}
              />
              <AddNewButton
                label={getMessage('addTopConsultant')}
                onClick={() => history.push(`/topConsultantsTypes/create`)}
              />
            </div>
          </div>
        }
      />
      <div style={{ width: '100%', height: '70vh' }} className="ag-theme-alpine">
        <AgGridReact
          ref={gridApi}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowData={rowData}
          rowSelection="single"
          rowGroupPanelShow="always"
          pivotPanelShow="always"
          onGridReady={onGridReady}
          onFirstDataRendered={sizeColumnsToFit}
          onRowDataUpdated={sizeColumnsToFit}
        />
      </div>
    </>
  )
}
